import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Link } from 'react-router-dom';
import { ApplicationLayout, Header } from 'axway-react-ui';
import { AwaitRestart } from 'components/widgets/Restart';
import ApplicationMenuContainer from 'components/pages/navigation/ApplicationMenuContainer';

const HOME_PAGE_PATH = `${window.$conf.prefix}/project/summary`;

class ProjectLayoutView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.renderNavigation = this.renderNavigation.bind(this);
		this.shareFeedbackText = this.intl.formatMsg('Share your feedback');
	}

	renderNavigation() {
		const { hasNav, fullscreen } = this.props;
		if (fullscreen || !hasNav) {
			return null;
		}
		return (
			<ApplicationLayout.Navigation>
				<ApplicationMenuContainer />
			</ApplicationLayout.Navigation>
		);
	}
	// The standard Axway Logo, but wrapped in a Link to the home page.
	AxwayLogo() {
		return (
			<Link to={HOME_PAGE_PATH}>
				<Header.Logo />
			</Link>
		);
	}

	render() {
		const { productName, projectName, fullscreen } = this.props;

		return (
			<div className={`project-layout ${fullscreen ? 'fullscreen' : ''}`}>
				<Header logo={this.AxwayLogo}>
					<Link to={HOME_PAGE_PATH} className="product-name">
						{productName}
					</Link>
					<span className="project-name">{projectName}</span>
					<div className="menu">
						<a
							href={window.$conf.feedbackUrl}
							role="button"
							className="hyperlink"
							target="_blank"
							// Using target="_blank" without
							// rel="noopener" is a security risk:
							// https://html.spec.whatwg.org/multipage/links.html#link-type-noopener
							rel="noopener noreferrer"
						>
							{this.shareFeedbackText}
						</a>
					</div>
				</Header>

				<ApplicationLayout hasHeader>
					{this.renderNavigation()}
					<ApplicationLayout.Content>
						{this.props.children}
						<AwaitRestart />
					</ApplicationLayout.Content>
				</ApplicationLayout>
			</div>
		);
	}
}

ProjectLayoutView.propTypes = {
	productName: PropTypes.string.isRequired,
	projectName: PropTypes.string.isRequired,
	// hides the nav and removes all content padding
	fullscreen: PropTypes.bool,
	// hides the nav retaining content padding
	hasNav: PropTypes.bool
};

ProjectLayoutView.defaultProps = {
	fullscreen: false,
	hasNav: true
};

// There is an issue with the HOC not using the defaultProps from components
// wrapped in injectIntl (https://github.com/formatjs/formatjs/issues/1258).
// This makes the intended defaultProps available on the wrapped component.
const WrappedProjectLayoutView = injectIntl(ProjectLayoutView);
WrappedProjectLayoutView.defaultProps = ProjectLayoutView.defaultProps;

export default WrappedProjectLayoutView;
